import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba meses despertándome a las 3 de la mañana sin poder volver a dormir. En 4 días empecé a notar cambios. Ahora duermo 5 horas seguidas sin interrupciones.',
    name: 'María',
    age: '47 años',
    image: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=120&h=120&fit=crop&crop=face&auto=format&q=80'
  }, {
    quote: 'No sabía que era por la menopausia. Pensaba que era estrés. Este plan me ayudó a entenderlo y a dormir mejor sin pastillas.',
    name: 'Carmen',
    age: '52 años',
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=120&h=120&fit=crop&crop=face&auto=format&q=80'
  }, {
    quote: 'Lo que más me sorprendió fue la energía. Dejé de despertarme cansada y la barriga empezó a desinflamarse sin hacer dieta.',
    name: 'Laura',
    age: '49 años',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&h=120&fit=crop&crop=face&auto=format&q=80'
  }];
  return <section className="py-24 bg-cream relative" data-id="element-231">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-232">
        <FadeIn data-id="element-233">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-charcoal mb-4" data-id="element-234">
            Más de 1.000 mujeres ya están aplicando este sistema
          </h2>
          <p className="text-center text-charcoal-muted text-lg mb-16" data-id="element-235">
            Esto es lo que dicen:
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-236">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-237">
              <div className="bg-white rounded-2xl p-8 shadow-card border border-cream-dark/40 h-full flex flex-col" data-id="element-238">
                <p className="text-charcoal-light leading-relaxed text-base flex-1 mb-6 italic" data-id="element-239">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4 pt-4 border-t border-cream-dark/30" data-id="element-240">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-cream-dark" data-id="element-241" />
                  <div data-id="element-242">
                    <p className="font-bold text-charcoal text-sm" data-id="element-243">
                      {testimonial.name}
                    </p>
                    <p className="text-charcoal-muted text-sm" data-id="element-244">
                      {testimonial.age}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}